import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import GET_LIST_BULK_ACTIONS from '../graphql/queries/get-list-bulk-actions.graphql';

export const useGetListBulkActions = (userId?: string | null) => {
    const {data, loading, networkStatus, error} = useQuery(GET_LIST_BULK_ACTIONS, {
        variables: {
            userId: userId,
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        listBulkActions: data ? data.listBulkActions : [],
        isLoading: loading,
        isFirstLoad: loading && networkStatus !== 3,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
